# frozen_string_literal: true

module Engine
  module Game
    module G1870
    end
  end
end
